import { makeEntityScaffold } from '@classpass/saga-tools';
export var emailOptIn = makeEntityScaffold('SAGA.API.EMAIL_OPT_IN', function (client, token) {
  return client.email.optIn(token);
});